/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { StedOplysninger } from '../models/sted-oplysninger';
import { ProjektSted } from '../models/projekt-sted';
import { EjendomSearchResponse } from '../models/ejendom-search-response';
import { EjerskabInfoResult } from '../models/ejerskab-info-result';
@Injectable({
  providedIn: 'root',
})
class LokaliteterService extends __BaseService {
static readonly getStedOplysningerPath = '/lokaliteter/stedoplysninger';
static readonly getMatrikelStedByPointPath = '/lokaliteter/matrikelstedbypoint';
static readonly getEjendomstedByJordstykkeIdPath = '/lokaliteter/ejendomstedbyjordstykkeid';
static readonly getEjendomsejerPath = '/lokaliteter/ejendomsejer';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param projektSted undefined
   * @return Success
   */
  private getStedOplysningerResponse(projektSted?: ProjektSted): __Observable<__StrictHttpResponse<StedOplysninger>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = projektSted;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/lokaliteter/stedoplysninger`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<StedOplysninger>;
      })
    );
  }

  /**
   * @param projektSted undefined
   * @return Success
   */
  getStedOplysninger(projektSted?: ProjektSted): __Observable<StedOplysninger> {
    return this.getStedOplysningerResponse(projektSted).pipe(
      __map(_r => _r.body as StedOplysninger)
    );
  }

  /**
   * @param params The `LokaliteterService.GetMatrikelStedByPointParams` containing the following parameters:
   *
   * - `y`:
   *
   * - `x`:
   *
   * @return Success
   */
  private getMatrikelStedByPointResponse(params: LokaliteterService.GetMatrikelStedByPointParams): __Observable<__StrictHttpResponse<EjendomSearchResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.y != null) __params = __params.set('y', params.y.toString());
    if (params.x != null) __params = __params.set('x', params.x.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/lokaliteter/matrikelstedbypoint`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<EjendomSearchResponse>;
      })
    );
  }

  /**
   * @param params The `LokaliteterService.GetMatrikelStedByPointParams` containing the following parameters:
   *
   * - `y`:
   *
   * - `x`:
   *
   * @return Success
   */
  getMatrikelStedByPoint(params: LokaliteterService.GetMatrikelStedByPointParams): __Observable<EjendomSearchResponse> {
    return this.getMatrikelStedByPointResponse(params).pipe(
      __map(_r => _r.body as EjendomSearchResponse)
    );
  }

  /**
   * @param jordstykkeId undefined
   * @return Success
   */
  private getEjendomstedByJordstykkeIdResponse(jordstykkeId: string): __Observable<__StrictHttpResponse<EjendomSearchResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (jordstykkeId != null) __params = __params.set('jordstykkeId', jordstykkeId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/lokaliteter/ejendomstedbyjordstykkeid`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<EjendomSearchResponse>;
      })
    );
  }

  /**
   * @param jordstykkeId undefined
   * @return Success
   */
  getEjendomstedByJordstykkeId(jordstykkeId: string): __Observable<EjendomSearchResponse> {
    return this.getEjendomstedByJordstykkeIdResponse(jordstykkeId).pipe(
      __map(_r => _r.body as EjendomSearchResponse)
    );
  }

  /**
   * @param projektSted undefined
   * @return Success
   */
  private getEjendomsejerResponse(projektSted?: ProjektSted): __Observable<__StrictHttpResponse<EjerskabInfoResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = projektSted;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/lokaliteter/ejendomsejer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<EjerskabInfoResult>;
      })
    );
  }

  /**
   * @param projektSted undefined
   * @return Success
   */
  getEjendomsejer(projektSted?: ProjektSted): __Observable<EjerskabInfoResult> {
    return this.getEjendomsejerResponse(projektSted).pipe(
      __map(_r => _r.body as EjerskabInfoResult)
    );
  }
}

module LokaliteterService {

  /**
   * Parameters for getMatrikelStedByPoint
   */
  export interface GetMatrikelStedByPointParams {
    y: number;
    x: number;
  }
}

export { LokaliteterService }
